import {
SET_CLASS_PRO_STATUS,
SET_CLASS_PRO_SCHOOL,
SET_CLASS_PRO_LEVEL,
SET_CLASS_PRO_FACULT,
SET_CLASS_PRO_USER
} from '@/store/mutation-types'

const changeSearchClassProStatus = ({commit, dispatch}, payload) => {
  commit(SET_CLASS_PRO_STATUS, payload)
}
const changeSearchClassProSchool = ({commit, dispatch}, payload) => {
  commit(SET_CLASS_PRO_SCHOOL, payload)
}
const changeSearchClassProLevel = ({commit, dispatch}, payload) => {
  commit(SET_CLASS_PRO_LEVEL, payload)
}
const changeSearchClassProFacult = ({commit, dispatch}, payload) => {
  commit(SET_CLASS_PRO_FACULT, payload)
}
const changeSearchClassProUser = ({commit, dispatch}, payload) => {
  commit(SET_CLASS_PRO_USER, payload)
}

export default {
  changeSearchClassProStatus,
  changeSearchClassProSchool,
  changeSearchClassProLevel,
  changeSearchClassProFacult,
  changeSearchClassProUser
}



// WEBPACK FOOTER //
// ./src/components/class-pros/store/actions.js